// extracted by mini-css-extract-plugin
module.exports =  {"PremiumButton":"fHxVR71LAAHKiLM6ZiCd"};